export default __webpack_public_path__ + "68a4a3ded4d7a64032117dbc4efc63c5.png";